import React from 'react';
import styled, { keyframes } from 'styled-components';

// Animação do spinner
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Container principal
const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
`;

// Spinner visual
const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid var(--color-bg-tertiary);
  border-radius: 50%;
  border-top-color: var(--color-text-primary);
  animation: ${spin} 1s linear infinite;
`;

// Texto de carregamento
const LoadingText = styled.p`
  color: var(--color-text-primary);
  font-size: 1rem;
  font-weight: 500;
  margin: 0;
  text-align: center;
  line-height: 1.5;
`;

const LoadingSpinner = () => {
  return (
    <SpinnerContainer>
      <Spinner />
      <LoadingText>
        Carregando...<br/>
        <small>Aguarde um momento</small>
      </LoadingText>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;